module.exports = __webpack_public_path__ + "img/Workflow.73b71914.svg";